import { Button, Typography } from '@mui/material'
import styles from './documentsPickerDialog.module.scss'

export default function DocumentsPickerFooter({
  selectedCount,
  maxSelectable,
  onCancel,
  onConfirm,
}) {
  const canConfirm = selectedCount > 0

  return (
    <footer className={styles.footer}>
      <Typography variant="body2" color="text.secondary" className={styles.footerHint}>
        {selectedCount > 0
          ? `${selectedCount} selected${maxSelectable > selectedCount ? ` · ${maxSelectable - selectedCount} more allowed` : ''}`
          : `Select up to ${maxSelectable} document${maxSelectable === 1 ? '' : 's'} to attach`}
      </Typography>
      <div className={styles.footerActions}>
        <Button type="button" variant="text" className={styles.cancelButton} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="button"
          variant="contained"
          className={styles.confirmButton}
          disabled={!canConfirm}
          onClick={onConfirm}
        >
          Attach{selectedCount > 0 ? ` (${selectedCount})` : ''}
        </Button>
      </div>
    </footer>
  )
}
